import { render, staticRenderFns } from "./RecursiveModel.vue?vue&type=template&id=1da6bfd4&scoped=true&"
import script from "./RecursiveModel.vue?vue&type=script&lang=ts&"
export * from "./RecursiveModel.vue?vue&type=script&lang=ts&"
import style0 from "./RecursiveModel.vue?vue&type=style&index=0&id=1da6bfd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da6bfd4",
  null
  
)

export default component.exports